const MoveSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
      <path
        d="M7.5 4.9974H2.08333M7.5 4.9974L5.83333 3.33073M7.5 4.9974L5.83333 6.66406"
        stroke="#333333"
        strokeWidth="0.833333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MoveSvg;
